/* eslint-disable prettier/prettier */

export const listAuditTrailsByProfile = /* GraphQL */ `
  query GetAuditTrailsByProfile(
    $profileID: ID!,
    $filter: ModelAuditTrailsFilterInput
    $limit: Int,
    $nextToken: String
  ) {
    listAuditTrailsByProfile(
      profileID: $profileID
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: DESC
    ) {
      items {
        changeJustification
        createdAt
        humanReadableLog
        id
        modifiedBy
        recordType
      }
      nextToken
    }
  }
`;

export const listAuditTrailsByEventId = /* GraphQL */ `
  query ListAuditTrailsByEventId(
    $eventId: ID!,
    $filter: ModelAuditTrailsFilterInput
    $limit: Int,
    $nextToken: String
  ) {
    listAuditTrailsByEventId(
      eventId: $eventId
      createdAt: { ge: "2024-05-13T00:00:00.000Z" }
      sortDirection: DESC
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        changeJustification
        createdAt
        humanReadableLog
        id
        modifiedBy
        recordType
      }
      nextToken
    }
  }
`;
